import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  constructor(private metaService: Meta, private titleService: Title) {}

  applyDefaultMeta() {
    const selectedCity = localStorage.getItem('selectedCityName') || 'India';
    const citySlug = selectedCity.toLowerCase().replace(/\s+/g, '-');

    const title = `Fuprop-Rental-Property-${citySlug}`;
    const description = `Find verified rental flats, apartments, villas, and commercial properties in ${selectedCity}. Discover the best real estate listings with FuProp.`;
    const keywords = `fuprop, rent in ${selectedCity}, rental flats, apartments, commercial property, ${selectedCity} real estate, property listings`;

    // Set dynamic title
    this.titleService.setTitle(title);

    // SEO meta tags
    this.metaService.updateTag({ name: 'description', content: description });
    this.metaService.updateTag({ name: 'keywords', content: keywords });
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });
    this.metaService.updateTag({ name: 'author', content: 'FuProp Team' });

    // Open Graph meta
    this.metaService.updateTag({ property: 'og:title', content: title });
    this.metaService.updateTag({ property: 'og:description', content: description });
    this.metaService.updateTag({ property: 'og:type', content: 'website' });


  }
}
